import React from 'react';

import styles from '../styles.module.scss';

interface Props {
  clickMarketingButton: () => void;
}

export default function AlarmBanner({clickMarketingButton}: Props) {
  return (
    <div className={styles.alarmBannerWrapper}>
      <div className={styles.txtArea}>
        알림 설정하고 새로운 혜택을 <br /> 가장 빠르게 확인하세요.
      </div>
      <div className={styles.alarmBtn} onClick={() => clickMarketingButton()}>
        <span className={styles.alarmIcon}></span>
        <span className={styles.alarmTxt}>오픈 알림 받기</span>
      </div>
    </div>
  );
}
